const defaultData = {
  // 企业列表数据
  companies: [
    {
      id: 1,
      name: "北京优易捷科技有限责任公司",
      createTime: "2025-04-05 21:59",
      isAuthorize: true,
      qrcodeList: [
        // 自定义二维码配置
        {
          name: "服务号二维码",
          content: "https://www.ucharts.cn/v2/#/", //
          size: 100, //二维码大小
          foregroundColor: "#333333", //二维码颜色
          backgroundColor: "#ffffff", //二维码背景颜色
          errorCorrectionLevel: "M", //二维码错误 correction level
        },
        {
          name: "订阅号二维码",
          content: "https://www.ucharts.cn/v2/#/", //
          size: 100, //二维码大小
          foregroundColor: "#333333", //二维码颜色
          backgroundColor: "#ffffff", //二维码背景颜色
          errorCorrectionLevel: "M", //二维码错误 correction level
        },
        {
          name: "小程序二维码",
          content: "https://www.ucharts.cn/v2/#/", //
          size: 100, //二维码大小
          foregroundColor: "#333333", //二维码颜色
          backgroundColor: "#ffffff", //二维码背景颜色
          errorCorrectionLevel: "M", //二维码错误 correction level
        },
      ],
      childrenList: [
        {
          type: 1,
          // 服务号-个人
          data: {
            name: "智联科创",
            fansCount: 123456,
            auditTime: "2025/04/05 21:59",
            expireTime: "2025/04/05 21:59",
            type: "服务号-个人",
            isOpenWechart: false,
            isOpenPC: true,
            logoUrl:
              "https://beihai-food.oss-cn-beijing.aliyuncs.com/pic/avatar.png",
            qrCodeUrl: "@/assets/qrcode_website.png",
            pcLink: {
              url: "https://example.com/payment-confirm",
              expireTime: "2025/04/05 21:59",
              logoUrl:
                "https://beihai-food.oss-cn-beijing.aliyuncs.com/pic/avatar.png",
            },
            myTemplates: [
              {
                id: 1,
                name: "智慧园区",
                status: "using",
                purchaseTime: "2025/04/05 21:59",
                expireTime: "2025/04/05 21:59",
                needRenew: true,
                isOpen: false,
              },
              {
                id: 2,
                name: "智慧园区",
                status: "notUsing",
                purchaseTime: "2025/04/05 21:59",
                expireTime: "2025/04/05 21:59",
                needRenew: false,
                isOpen: false,
              },
              {
                id: 3,
                name: "智慧园区",
                status: "notUsing",
                purchaseTime: "2025/04/05 21:59",
                expireTime: "2025/04/05 21:59",
                needRenew: false,
                isOpen: false,
              },
            ],
          },
        },
        {
          type: 2,
          // 订阅号-企业
          data: {
            name: "智联科创",
            auditTime: "2025/04/05 21:59",
            expireTime: "2025/04/05 21:59",
            isOpenWechart: false,
            isOpenPC: false,
            type: "订阅号-企业",
            logoUrl:
              "https://beihai-food.oss-cn-beijing.aliyuncs.com/pic/avatar.png",
            qrCodeUrl: "@/assets/qrcode_service.png",
            pcLink: {
              url: "https://example.com/payment-confirm",
              expireTime: "2025/04/05 21:59",
              logoUrl:
                "https://beihai-food.oss-cn-beijing.aliyuncs.com/pic/avatar.png",
            },
            myTemplates: [
              {
                id: 1,
                name: "智慧园区",
                status: "using",
                purchaseTime: "2025/04/05 21:59",
                expireTime: "2025/04/05 21:59",
                needRenew: true,
                isOpen: false,
              },
              {
                id: 2,
                name: "智慧园区",
                status: "notUsing",
                purchaseTime: "2025/04/05 21:59",
                expireTime: "2025/04/05 21:59",
                needRenew: false,
                isOpen: false,
              },
            ],
          },
        },
        {
          type: 3,
          // 小程序
          data: {
            name: "智联科创",
            auditTime: "2025/04/05 21:59",
            expireTime: "2025/04/05 21:59",
            isOpenWechart: false,
            isOpenPC: false,
            type: "小程序",
            logoUrl:
              "https://beihai-food.oss-cn-beijing.aliyuncs.com/pic/avatar.png",
            qrCodeUrl: "@/assets/qrcode_service.png",
            pcLink: {
              url: "https://example.com/payment-confirm",
              expireTime: "2025/04/05 21:59",
              logoUrl:
                "https://beihai-food.oss-cn-beijing.aliyuncs.com/pic/avatar.png",
            },
            myTemplates: [
              {
                id: 1,
                name: "智慧园区",
                status: "using",
                purchaseTime: "2025/04/05 21:59",
                expireTime: "2025/04/05 21:59",
                needRenew: true,
                isOpen: false,
              },
            ],
          },
        },
      ],
    },
    {
      id: 2,
      name: "北京汇信德科技有限责任公司",
      createTime: "2025-04-05 21:59",
      isAuthorize: false,
      qrcodeList: [
        // 自定义二维码配置
        {
          name: "服务号二维码",
          content: "https://www.ucharts.cn/v2/#/", //
          size: 100, //二维码大小
          foregroundColor: "#333333", //二维码颜色
          backgroundColor: "#ffffff", //二维码背景颜色
          errorCorrectionLevel: "M", //二维码错误 correction level
        },
        {
          name: "订阅号二维码",
          content: "https://www.ucharts.cn/v2/#/", //
          size: 100, //二维码大小
          foregroundColor: "#333333", //二维码颜色
          backgroundColor: "#ffffff", //二维码背景颜色
          errorCorrectionLevel: "M", //二维码错误 correction level
        },
        {
          name: "小程序二维码",
          content: "https://www.ucharts.cn/v2/#/", //
          size: 100, //二维码大小
          foregroundColor: "#333333", //二维码颜色
          backgroundColor: "#ffffff", //二维码背景颜色
          errorCorrectionLevel: "M", //二维码错误 correction level
        },
      ],
      childrenList: [
        {
          type: 1,
          // 服务号-个人
          data: {
            name: "智联科创",
            fansCount: 123456,
            auditTime: "2025/04/05 21:59",
            expireTime: "2025/04/05 21:59",
            type: "服务号-个人",
            isOpenWechart: false,
            isOpenPC: true,
            logoUrl:
              "https://beihai-food.oss-cn-beijing.aliyuncs.com/pic/avatar.png",
            qrCodeUrl: "@/assets/qrcode_website.png",
            pcLink: {
              url: "https://example.com/payment-confirm",
              expireTime: "2025/04/05 21:59",
              logoUrl:
                "https://beihai-food.oss-cn-beijing.aliyuncs.com/pic/avatar.png",
            },
            myTemplates: [
              {
                id: 1,
                name: "智慧园区",
                status: "using",
                purchaseTime: "2025/04/05 21:59",
                expireTime: "2025/04/05 21:59",
                needRenew: false,
                isOpen: false,
              },
            ],
          },
        },
        {
          type: 2,
          // 订阅号-企业
          data: {
            name: "智联科创",
            auditTime: "2025/04/05 21:59",
            expireTime: "2025/04/05 21:59",
            isOpenWechart: false,
            isOpenPC: false,
            type: "订阅号-企业",
            logoUrl:
              "https://beihai-food.oss-cn-beijing.aliyuncs.com/pic/avatar.png",
            qrCodeUrl: "@/assets/qrcode_service.png",
            pcLink: {
              url: "https://example.com/payment-confirm",
              expireTime: "2025/04/05 21:59",
              logoUrl:
                "https://beihai-food.oss-cn-beijing.aliyuncs.com/pic/avatar.png",
            },
            myTemplates: [
              {
                id: 1,
                name: "智慧园区",
                status: "using",
                purchaseTime: "2025/04/05 21:59",
                expireTime: "2025/04/05 21:59",
                needRenew: false,
                isOpen: false,
              },
            ],
          },
        },
        {
          type: 3,
          // 小程序
          data: {
            name: "智联科创",
            auditTime: "2025/04/05 21:59",
            expireTime: "2025/04/05 21:59",
            isOpenWechart: false,
            isOpenPC: false,
            type: "小程序",
            logoUrl:
              "https://beihai-food.oss-cn-beijing.aliyuncs.com/pic/avatar.png",
            qrCodeUrl: "@/assets/qrcode_service.png",
            pcLink: {
              url: "https://example.com/payment-confirm",
              expireTime: "2025/04/05 21:59",
              logoUrl:
                "https://beihai-food.oss-cn-beijing.aliyuncs.com/pic/avatar.png",
            },
            myTemplates: [
              {
                id: 1,
                name: "智慧园区",
                status: "using",
                purchaseTime: "2025/04/05 21:59",
                expireTime: "2025/04/05 21:59",
                needRenew: true,
                isOpen: false,
              },
            ],
          },
        },
      ],
    },
  ],
  list: {
    // 全局配置
    global: {
      bgColor: "rgba(249, 249, 249, 10)",
      bgImg: "",
      customColor: "rgba(31, 241, 199, 1)",
      details: "",
      enterpriseName: "企业名称",
      isPerson: false,
      // 顶部导航栏左侧返回按钮的文字
      leftContent: "",
      // 顶部导航栏标题
      name: "页面标题11",
      // 顶部导航栏右侧是否有内容
      rightContent: "",
      // 顶部导航栏是否带边框
      showBorder: true,
      // 顶部导航栏是否显示左侧返回按钮
      showLeftArrow: false,
    },
    // 页面配置
    pages: [
      {
        components: [
          {
            active: false,
            component: "commoditysearch",
            id: "page_commoditysearch",
            setStyle: {
              text: "商品搜索",
              heights: 28,
              position: 0,
              sweep: false,
              borderRadius: 0,
            },
            style: "commoditysearchstyle",
            text: "商品搜索",
            type: "1-1",
          },
          {
            active: false,
            component: "captiontext",
            id: "page_captiontext",
            setStyle: {
              backColor: "rgba(255, 255, 255, 10)",
              borderBott: false,
              description: "这里是描述内容",
              descriptionColor: "rgba(150, 151, 153, 10)",
              descriptionSize: 12,
              descriptionWeight: 200,
              id: "page_captiontext",
              more: {
                http: "",
                httpType: 10,
                show: true,
                text: "查看更多",
                type: 1,
              },
              name: "标题文本",
              positions: "left",
              text: "标题文本",
              wordColor: "rgba(50, 50, 51, 10)",
              wordHeight: 24,
              wordSize: 16,
              wordWeight: 400,
            },
            style: "captiontextsstyle",
            text: "标题文本",
            type: "1-1",
          },
          {
            active: true,
            activeIndex: 0,
            component: "tabbar",
            id: "page_tabbar",
            setStyle: {
              text: "底部导航",
              activeColor: "#1989fa",
              inactiveColor: "#7d7e80",
              isShowBorder: true,
              iconWidth: "25",
            },
            style: "tabbarstyle",
            text: "底部导航",
            type: "2-1",
          },
        ],
        isBack: false,
        pageId: "page_home",
        pageName: "首页",
        pageSetup: {
          name: "页面标题",
          leftContent: "",
          showLeftArrow: false,
          details: "",
          showBorder: true,
        },
      },
      {
        components: [],
        isBack: false,
        pageId: "page_notification",
        pageName: "通知",
        pageSetup: {
          name: "页面标题",
          leftContent: "",
          showLeftArrow: false,
          details: "",
          showBorder: true,
        },
      },
      {
        components: [],
        isBack: false,
        pageId: "page_activity",
        pageName: "活动",
        pageSetup: {
          name: "页面标题",
          leftContent: "",
          showLeftArrow: false,
          details: "",
          showBorder: true,
        },
      },
      {
        components: [],
        isBack: false,
        pageId: "page_user",
        pageName: "我的",
        pageSetup: {
          name: "页面标题",
          leftContent: "",
          showLeftArrow: false,
          details: "",
          showBorder: true,
        },
      },
    ],
    // 底部导航栏配置
    tabBar: {
      active: true,
      activeIndex: 0,
      component: "tabbar",
      id: "page_tabbar",
      setStyle: {
        Highlight: 0,
        active: 0,
        activeColor: "#1989fa",
        fontSize: "14",
        iconHeight: "25",
        iconList: [
          {
            http: { url: "" },
            iconName: "首页",
            iconPic:
              "https://img2.baidu.com/it/u=1905875968,4289754134&fm=26&fmt=auto&gp=0.jpg",
            iconText: "首页",
            inactive:
              "https://img2.baidu.com/it/u=1905875968,4289754134&fm=26&fmt=auto&gp=0.jpg",
            isDot: false,
            isShow: true,
            linktype: "10",
            path: "home",
          },
          {
            http: { url: "" },
            iconName: "通知",
            iconPic:
              "https://img2.baidu.com/it/u=1905875968,4289754134&fm=26&fmt=auto&gp=0.jpg",
            iconText: "通知",
            inactive:
              "https://img2.baidu.com/it/u=1905875968,4289754134&fm=26&fmt=auto&gp=0.jpg",
            isDot: false,
            isShow: false,
            linktype: "10",
            path: "notification",
          },
          {
            http: { url: "" },
            iconName: "活动",
            iconPic:
              "https://img2.baidu.com/it/u=1905875968,4289754134&fm=26&fmt=auto&gp=0.jpg",
            iconText: "活动",
            inactive:
              "https://img2.baidu.com/it/u=1905875968,4289754134&fm=26&fmt=auto&gp=0.jpg",
            isDot: false,
            isShow: false,
            linktype: "10",
            path: "activity",
          },
          {
            http: { url: "" },
            iconName: "我的",
            iconPic:
              "https://img2.baidu.com/it/u=1905875968,4289754134&fm=26&fmt=auto&gp=0.jpg",
            iconText: "我的",
            inactive:
              "https://img2.baidu.com/it/u=1905875968,4289754134&fm=26&fmt=auto&gp=0.jpg",
            isDot: false,
            isShow: false,
            linktype: "10",
            path: "user",
          },
        ],
        iconWidth: "25",
        id: "page_tabbar",
        inactiveColor: "#7d7e80",
        isShowBorder: true,
        text: "底部导航",
      },
      style: "tabbarstyle",
      text: "底部导航",
      type: "2-1",
    },
  },
};
export const companies = defaultData.companies;
